import { configureStore } from '@reduxjs/toolkit';
import userAPI from './api/userAPI';
import notifications from './notification/notifications';
import illegalWasteDumpsAPI from './api/illegalWasteDumpsAPI';
import wasteCategoriesAPI from './api/wasteCategoriesAPI';
import mapCoordinates from "./map/mapCoordinates";
import filterValues from "./filter/filterValues";

const store = configureStore({
	reducer: {
		notifications,
		illegalWasteDumpsAPI,
		userAPI,
		wasteCategoriesAPI,
		mapCoordinates,
		filterValues,
	},
});

export default store;
